import { render, staticRenderFns } from "./ReviewForm.vue?vue&type=template&id=6a75528a&"
import script from "./ReviewForm.vue?vue&type=script&lang=ts&"
export * from "./ReviewForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports